export const PAGEPUFF = "pagePuff";
export const LISTELEMENT = "listElement";
export const MAPBLOCK = "mapBlock";
export const CONCEPTS = "conceptContainer";
export const QUOTATIONBLOCK = "quotationBlock";
export const PARALLAXBLOCK = "parrallaxElement";
export const EMPLOYEELISTBLOCK = "contactContainer";
export const FORMELEMENT = "formElement";
export const VIDEOLISTBLOCK = "videoListBlock";
export const VIDEOBLOCK = "videoBlock";
export const LINKBLOCK = "linkBlock";
export const LINKBLOCKCONTAINER = "linkBlockContainer";
export const TEXTBLOCK = "textBlock";
export const COLUMNELEMENT = "columnElement";
export const FAQBLOCK = "faqBlock";
export const INFOBLOCK = "infoBlock";
export const STICKYBLOCK = "stickyBlock";
export const SLIDESHOW = "slideShow";
